// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3frp7","contactTitle":"Contact_contactTitle__pSZe5","contactBlock":"Contact_contactBlock__379BM","contactLinkBox":"Contact_contactLinkBox__30Wm6"};